export default __webpack_public_path__ + "static/media/Seaweed60capbottle-1.c6dafc2d.jpg";